/**
 * عکسِ اینترنتی که اگر لود نشد، به‌جای آیکونِ شکسته‌ی مرورگر یک تصویرِ
 * جایگزینِ تمیز می‌گذارد (WHOSUP-302) — قرینه‌ی `ImageOrTiles` در موبایل.
 *
 * خرابی همان‌طور گزارش می‌شود (`reportBrokenImage` → سربرگِ «عکس‌ها»ی
 * ادمین). ترتیبِ امتحانِ آدرس‌ها در core است (`lib/eventImage`).
 */
import React, { useEffect, useMemo, useState } from 'react';
import { imageSources, nextImageSource } from '@/core/lib/eventImage';
import { reportBrokenImage } from '@/core/lib/report';
import { CategoryIcon } from '@/ui/icons';

export function SafeImg({ src, className, screen, slug, loading }: {
  src?: string | null;
  /** کلاسِ قاب — جایگزین هم همان را می‌گیرد تا جای عکس عیناً پر شود. */
  className: string;
  /** برای گزارش: کدام صفحه. */
  screen: string;
  /** دسته‌ی آیتم برای آیکونِ جایگزین. */
  slug?: string;
  loading?: 'lazy' | 'eager';
}) {
  const sources = useMemo(() => imageSources(src), [src]);
  const [shown, setShown] = useState<string | null>(sources[0] ?? null);
  useEffect(() => { setShown(sources[0] ?? null); }, [sources]);

  if (sources.length === 0) return null;
  if (!shown) {
    return (
      <span className={`${className} img-fallback`} data-testid="img-fallback" aria-hidden="true">
        <CategoryIcon slug={slug ?? 'other'} size={28} />
      </span>
    );
  }
  return (
    <img className={className} src={shown} alt="" loading={loading}
      onError={() => {
        reportBrokenImage(shown, screen);
        setShown((prev) => nextImageSource(sources, prev));
      }} />
  );
}
